import WhatsAppRequestForm, { VIEW } from './WhatsAppRequestForm';

export { VIEW };

export default WhatsAppRequestForm;
